import rest from "@/utils/rest";
export default {
  GetList: () => {
    let link = "CarWash";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  GetCarWash: (id) => {
    let link = "CarWash/" + id;
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  GetAllowedProductList: () => {
    let link = "CarWash/GetAllowedProductList";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  GetLimitList: () => {
    let link = "CarWash/Limit";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },

  UpdateCarWash: (
    carWashID,
    name,
    taxCode,
    address,
    phoneNumber,
    contactPerson
  ) => {
    let link = "CarWash/UpdateCarWash";
    let formData1 = {
      carWashID: carWashID,
      name: name,
      taxCode: taxCode,
      address: address,
      phoneNumber: phoneNumber,
      contactPerson: contactPerson,
    };
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  UpdateLimit: (
    id,
    carWashId,
    limitAmount,
    productId,
    limitTypeID,
    isMain,
    enabled
  ) => {
    let link = "CarWash/UpdateLimit";
    let formData1 = {
      id: id,
      carWashId: +carWashId,
      limitAmount: +limitAmount,
      productId: +productId,
      LimitTypeID: limitTypeID,
      isMain: isMain,
      enabled: enabled,
    };
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "PATCH",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  DisableLimit: (id) => {
    let link = "CarWash/DisableLimit/" + id;
    return rest
      .channel(link, {
        method: "DELETE",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  EnableLimit: (id) => {
    let link = "CarWash/EnableLimit/" + id;
    return rest
      .channel(link, {
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  AddNewCarWash: (name, taxCode, address, phoneNumber, contactPerson) => {
    let link = "CarWash/AddNewCarWash";
    let formData1 = {
      name: name,
      taxCode: taxCode,
      address: address,
      phoneNumber: phoneNumber,
      contactPerson: contactPerson,
    };
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "PUT",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  DisableCarWash: (id) => {
    let link = "CarWash/DisableCarWash/" + id;
    return rest
      .channel(link, {
        method: "DELETE",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  EnableCarWash: (id) => {
    let link = "CarWash/EnableCarWash/" + id;
    return rest
      .channel(link, {
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },

  AddUser: (userName, carWashId, roleID) => {
    let link = "CarWash/User/Add";
    let formData1 = {
      userName: userName,
      carWashId: carWashId,
      roleID: roleID,
    };
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "PUT",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  DisableUser: (id) => {
    let link = "CarWash/User/Disable/" + id;
    return rest
      .channel(link, {
        method: "DELETE",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  EnableUser: (id) => {
    let link = "CarWash/User/Enable/" + id;
    return rest
      .channel(link, {
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  ResetUserPassword: (id) => {
    let link = "CarWash/User/ResetPassword/" + id;
    return rest
      .channel(link, {
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  RefreshUserAttampts: (id) => {
    let link = `CarWash/User/RefreshUserLockingAttampts/${id}`;
    return rest
      .channel(link, {
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
};
